<main id="home" class="main">
  <div class="main__container">
    <div class="main__info">
      <h1 class="name">Sebastian Sierra</h1>
      <p class="occupation">Frontend Developer</p>
    </div>
    <img class="main__avatar" src="assets/avatar.png" alt="avatar Sebastian Sierra">
  </div>
</main>
